export default "__VITE_ASSET__BPzxDhO7__"